<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">캐터옥션 리포트</h2>
            </div>

            <router-view name="board" code="report" skin="board-normal" hide-write-button v-bind="{ category }" />
        </v-container>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";

export default {
    components: {
        ClientPage,
    },
    computed: {
        category() {
            return this.$route.query.category || undefined;
        },
    },
};
</script>
